import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { useUser } from "$global-providers/user-provider";
import { Role } from "elephant-web/gql";
import { useMemo } from "react";

const {
  CashOfficer,
  Clinic,
  Doctor,
  Pharmacist,
  Technician,
  Nurse,
  Dispenser,
  Admin,
} = Role;

export const INVOICING_ROLES: Role[] = [
  Doctor,
  Pharmacist,
  Technician,
  Nurse,
  Dispenser,
];
export const REFUNDING_ROLES: Role[] = [Clinic, CashOfficer, Admin];

export interface InvoicingPermissions {
  refunds: boolean;
  waive: boolean;
  exemption: boolean;
  finalise: boolean;
  void: boolean;
}

export function usePermissions(): InvoicingPermissions {
  const { role: roleName } = useUser();

  const [paymentsFF] = useFeatureFlag(featureFlags.billing.payments);
  const [blockRefundsFF] = useFeatureFlag(featureFlags.billing.blockRefunds);
  const [blockWaiveFF] = useFeatureFlag(featureFlags.billing.blockWaive);
  const [exemptionFF] = useFeatureFlag(featureFlags.billing.exemption);

  const allowedRoles = roleName === Clinic || roleName === CashOfficer;
  const canFinalise =
    roleName !== undefined && INVOICING_ROLES.includes(roleName);
  const canRefund =
    roleName !== undefined && REFUNDING_ROLES.includes(roleName);
  const canVoid = roleName === Role.Admin || roleName === Clinic;

  return useMemo(
    () => ({
      refunds: !blockRefundsFF && canRefund, // Inverting featureFlag to make all perms positive
      waive: !blockWaiveFF, // Inverting to make all perms positive
      exemption: exemptionFF,
      finalise: (paymentsFF && canFinalise) || allowedRoles,
      void: canVoid,
    }),
    [
      blockRefundsFF,
      canRefund,
      blockWaiveFF,
      exemptionFF,
      paymentsFF,
      canFinalise,
      allowedRoles,
      canVoid,
    ],
  );
}
